import { Reveal } from "./Reveal";
import { FAQS } from "../data/siteData";

export const Faq = () => (
  <section className="border-t border-amber-500/10 py-24" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-6 lg:px-10">
      <Reveal>
        <p className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-amber-400/80">Good to Know</p>
        <h2 className="mt-5 font-display text-3xl font-light tracking-tight text-amber-50 sm:text-4xl">
          Questions, <em className="text-gold-gradient not-italic">answered.</em>
        </h2>
      </Reveal>
      <div className="mt-12">
        {FAQS.map((f, i) => (
          <Reveal key={f.q} delay={i * 0.06}>
            <div className="border-b border-white/5 py-7" data-testid={`faq-item-${i}`}>
              <h3 className="font-display text-xl font-normal text-amber-100 sm:text-2xl">{f.q}</h3>
              <p className="mt-3 max-w-2xl text-sm font-light leading-relaxed text-stone-400">{f.a}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
